<template>
  <div class="trafficTop">
    <div v-for="(item, index) in lister" :key="index" class="traButton" @click="trafficTopUp(item)">
      <div>
        <div>
          <span class="comboText">{{ item.comboDesc }}</span>
        </div>
        <p class="comboPrice">{{ item.sellingPrice.toFixed(2) }}元</p>
      </div>
    </div>
    <van-popup v-model="show" :close-on-click-overlay="false" class="popupPay" :round="true">
      <p>请选择支付方式</p>
      <img :src="zfb" @click="Pay(1)" />
      <img :src="wx" @click="Pay(0)" />
      <span @click="overPay">取消支付</span>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import global from './globel'
export default {
  props: ['lister', 'zfb', 'wx'],
  data () {
    return {
      show: false, //选择支付类型的窗口
      idRecharge: '', //充值套餐的id
      payPost: '', //不同网站的支付路径
      isClick: false
    }
  },
  mounted () {
    this.globel.detectDeviceType(this)
  },
  methods: {
    //支付
    Pay (payType) {
      let comboId = this.idRecharge
      let msisdn = this.$attrs.msisdn
      let form = { ...this.$attrs.form, comboId, msisdn, payType }
      if (this.isClick)      {
        return
      }
      this.isClick = true
      setTimeout(() => {
        this.isClick = false
      }, 3000)
      this.globel.showLoading('查询中...')
      this.globel.requestUrl('/recharge/createRechargeCus', form).then(res => {
        let out_trade_no = res.tradeNo
        Toast.clear()
        if (res.success === true)        {
          if (payType === 1)          {
            //支付宝支付
            location.href = global.data.post + this.payPost + '?out_trade_no=' + out_trade_no
          } else if (payType === 0)          {
            //微信支付
            //判断是否是在微信内支付
            if (/MicroMessenger/.test(window.navigator.userAgent))            {
              sessionStorage.setItem('out_trade_no', out_trade_no)
              sessionStorage.setItem('msisdn', msisdn)
              location.href = 'https://icmp.shingsou.com/wxPay/openIdRedirect'
            } else            {
              this.globel.requestUrl('/wxPay/pay', { out_trade_no: out_trade_no, trade_type: 'NATIVE' }).then(res => {
                this.$router.push('/scanToPay?code_url=' + res.code_url + '&msisdn=' + msisdn)
              }).catch(err => { })
            }
          }
        }
      })
    },
    /* 充值流量 */
    trafficTopUp (item) {
      let { accountType, accountDate } = this.$attrs.form
      if (accountType == 2 && accountDate == '')      {
        Toast('请选择到账时间')
        return
      }
      this.show = true
      this.idRecharge = item.id
    },
    //取消支付
    overPay () {
      this.show = false
      this.idRecharge = ''
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
.trafficTop {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (max-width: 1000px) {
  .comboText {
    font-size: 12px;
  }
  .comboPrice {
    font-size: 12px;
  }
}
@media screen and (min-width: 1000px) {
  .comboText {
    font-size: 16px;
  }
  .comboPrice {
    font-size: 13px;
  }
}
.traButton {
  box-sizing: border-box;
  width: calc(33.3% - 6.66px);
  display: inline-block;
  border: 0.1rem solid rgb(255, 183, 69);
  border-radius: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  & > div {
    height: 5.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & > div {
      color: rgb(255, 122, 88);
      span {
        font-weight: bold;
      }
    }
  }
  p {
    color: rgb(102, 102, 102);
    font-size: 1.2rem;
  }
}
.traButton:nth-of-type(3n) {
  margin-right: 0;
}
.popupPay {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-size: 15px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color: rgb(51, 51, 51);
    width: 80%;
    border-bottom: 1px solid rgb(219, 219, 219);
  }
  span {
    color: rgb(64, 158, 255);
  }
  p,
  img,
  span {
    margin-bottom: 20px;
  }
}
</style>
